import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async listImagesPaginated(
        { commit, dispatch },
        { complete, keyword, page, size }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/images", {
                params: { page, complete, keyword, size }
            });
            const images = data.items;
            commit("ADD_IMAGES", images);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async getEndPointUploadImage(
        { commit, dispatch },
        { alt, entity, fileName, fileSize, id, size }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/images/upload", {
                fileName,
                fileSize,
                alt,
                size,
                id,
                entity
            });

            commit("SET_URL_UPLOAD", data);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async listSharedImagesPaginated(
        { commit, dispatch },
        { complete, keyword, page, size }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/images/shared", {
                params: { page, complete, keyword, size }
            });
            commit("ADD_IMAGES", data.items);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async getEndPointUploadSharedImage(
        { commit, dispatch },
        { alt, fileName, fileSize, id, size }
    ) {
        try {
            const { data } = await Http.instance.post(
                "/bo/images/shared/upload",
                { fileName, fileSize, alt, size, id }
            );

            commit("SET_URL_UPLOAD", data);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async uploadImage({ commit, dispatch }, { file, url }) {
        try {
            const res = await fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Cache-Control": "max-age=31536000"
                },
                body: file
            });
            const status = res.status;
            return { status };
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async getImageById({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.get(`/bo/images/${id}`);

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async createImage({ commit, dispatch }, { alt, id, size, url }) {
        try {
            const { data } = await Http.instance.post("/bo/images", {
                id,
                url,
                alt,
                size
            });

            const image = {
                url,
                alt,
                size,
                ...data
            };
            return image;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async createSharedImage({ commit, dispatch }, { alt, id, size, url }) {
        try {
            const { data } = await Http.instance.post("/bo/images/shared", {
                id,
                url,
                alt,
                size
            });

            const image = {
                url,
                alt,
                size,
                ...data
            };
            return image;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async updateImage({ commit, dispatch }, { alt, id, size }) {
        try {
            const { data } = await Http.instance.patch(`/bo/images/${id}`, {
                alt,
                size
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async updateSharedImage({ commit, dispatch }, { alt, id, size }) {
        try {
            const { data } = await Http.instance.patch(
                `/bo/images/shared/${id}`,
                { alt, size }
            );

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async deleteImage({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.delete(`/bo/images/${id}`);

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async deleteSharedImage({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.delete(
                `/bo/images/shared/${id}`
            );

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async deleteImageDefinitively({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.delete(
                `/bo/images/${id}/definitive`
            );

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    },
    async deleteSharedImageDefinitively({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.delete(
                `/bo/images/shared/${id}/definitive`
            );

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_IMAGES", parseError);
            throw parseError;
        }
    }
};

export default actions;
